import React from "react";
//npm install --save react-qr-scanner
import QrReader from "react-qr-scanner";
import { Link } from "react-router-dom";
import { withAlert } from "react-alert";

import DataSender from "../lib/DataSender";

class QRRead extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      result: "",
    };
    this.alert = this.props.alert;
    this.ds = new DataSender();
    this.cancel = this.props.location.state.cancel
      ? this.props.location.state.cancel
      : "/Main";
  }

  handleScan = (data) => {
    if (data == null) {
      return;
    }
    this.ds
      .access(data)
      .then((response) => {
        if (response.status === 404) {
          this.alert.show("등록되지 않은 사용자입니다.");
        } else {
          return response;
        }
        throw new Error();
      })
      .then((response) => response.json())
      .then((response) => {
        let to = this.props.location.state.to;
        this.props.history.push({
          pathname: to,
          state: { ...response },
        });
      })
      .catch((err) => {});
  };

  handleError = (err) => {
    // throw err
  };

  render() {
    return (
      <div className="Qrread">
        <div>
          <h1 style={{ marginTop: "30px" }}>
            [{this.props.location.state.text}] QR코드를 카메라에 보이게 해주세요
          </h1>
          <p>　</p>
          <QrReader
            onError={this.handleError}
            onScan={this.handleScan}
            style={{ width: "640px" }}
          />
        </div>
        <p>　</p>
        <div className="qrread-buttons">
          <Link
            to={{
              pathname: "/PhoneRead",
              state: { to: this.props.location.state.to, cancel: this.cancel },
            }}
            className="qrread-button1"
          >
            <button className="button">
              <p>전화번호</p>
            </button>
          </Link>
          <Link
            to={{
              pathname: "/DtRead",
              state: { to: this.props.location.state.to, cancel: this.cancel },
            }}
            className="qrread-button2"
          >
            <button className="button">
              <p>군번</p>
            </button>
          </Link>
          <Link to={this.cancel} className="qrread-button3">
            <button className="button">
              <p>취소</p>
            </button>
          </Link>
        </div>
      </div>
    );
  }
}

export default withAlert()(QRRead);
